import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {
  private mobileRegex = /Mobi|Android|iPhone|iPad|iPod/i;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  public isMobileDevice(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return this.mobileRegex.test(navigator.userAgent);
    }
    return false;
  }
}
